import { TODO } from '@b2c/types/index';
import angular from 'angular';
import { CalendarServiceModule } from '../calendar/calendar.service';
import { QueryStringBuilderFactoryModule } from '@b2c/common/factories/QueryStringBuilder/QueryStringBuilder.factory';
import { ApiVersionFactoryModule } from '@b2c/common/factories/apiVersion/apiVersion.factory';
import { HelpersServiceModule } from '../helpers/helpers.service';

export const ComboServiceModule = angular.module('acme.common.service.combo', [
  CalendarServiceModule,
  HelpersServiceModule,
  QueryStringBuilderFactoryModule,
  ApiVersionFactoryModule
])
.service('ComboService', [ '$http', '$q', '$timeout', 'QueryStringBuilderFactory', 'CalendarService', 'HelpersService', 'ApiVersionFactory', function($http, $q, $timeout, QueryStringBuilderFactory, CalendarService, HelpersService, ApiVersionFactory) {

    return {

      api: {

        av_combo: new ApiVersionFactory({
          url: '/v1/b2c/combo',
          version: 'v2'
        }),

        list: function(tenantId, props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['summary']
            }
          });

          return $http({
            method: 'get',
            headers: {
              'x-b2c-tenant-id': tenantId
            },
            url: this.av_combo.url  + '/event/templates' + qs.query
          });
        },

        detail: function(props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['summary']
            }
          });

          return $http({
            method: 'get',
            headers: {
              'x-b2c-tenant-id': props.tenantId
            },
            url:  this.av_combo.url + '/event/templates/' + props.comboTemplateId + qs.query
          });
        },

        nextAvailable: function(props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['startTime', 'eventTemplateIds', 'saleChannel']
            }
          });

          return $http({
            method: 'get',
            headers: {
              'x-b2c-tenant-id': props.tenantId
            },
            url: this.av_combo.url + '/events/' + props.comboTemplateId + '/nextavailable' + qs.query
          });
        },

        templateCalendar: function(props) {
          var qs = new QueryStringBuilderFactory({
            props: props,
            fields: {
              optional: ['startTime', 'endTime', 'saleChannel', 'templateIds']
            }
          });

          return $http({
            method: 'get',
            headers: {
              'x-b2c-tenant-id': props.tenantId
            },
            url: this.av_combo.url + '/events/' + props.comboTemplateId + '/calendar' + qs.query
          });
        }
      },

      init: function() {
        return true;
      },

      /**
       * Search for id given an array of combos
       *
       * @param combos
       * @param id
       * @returns {boolean}
       */
      findCombo: function(combos, id) {
        var i, ii,
            r = false;

        console.log('ComboService::findCombo', combos, id);
        for (i=0,ii=combos.length;i<ii;i++) {
          if (combos[i].id === id) {
            r = combos[i];
            break;
          }
        }

        return r;
      },
      
      findEventTemplate: function(combo, id) {
        var i, ii,
            j, jj,
            r = false,
            events = this.getTemplatesByType(combo, 'event'),
            any = this.getTemplatesByType(combo, 'any');

        if (events) {
          for (i=0,ii=events.length;i<ii;i++) {
            if (events[i].id === id) {
              r = events[i];
              console.log('ComboService::findEventTemplate', r);
              break;
            }
          }
        }

        if (!r && any) {
          outer: for (i=0,ii=any.length;i<ii;i++) {
            for (j=0,jj=any[i].summaries.length;j<jj;j++) {
              if (any[i].summaries[j].id === id) {
                r = any[i].summaries[j];
                console.log('ComboService::findEventTemplate', r);
                break outer;
              }
            }
          }
        }

        return r;
      },

      findEventTemplateByName: function(combo, name) {
        var i, ii,
            j, jj,
            r = false,
            events = this.getTemplatesByType(combo, 'event'),
            any = this.getTemplatesByType(combo, 'any');

        if (events) {
          for (i=0,ii=events.length;i<ii;i++) {
            if (events[i].name === name) {
              r = events[i];
              console.log('ComboService::findEventTemplateByName', r);
              break;
            }
          }
        }

        if (!r && any) {
          outer: for (i=0,ii=any.length;i<ii;i++) {
            for (j=0,jj=any[i].summaries.length;j<jj;j++) {
              if (any[i].summaries[j].name === name) {
                r = any[i].summaries[j];
                console.log('ComboService::findEventTemplateByName', r);
                break outer;
              }
            }
          }
        }

        return r;
      },

      getEventTemplateIds: function(combo) {
        var result: TODO[] = [];
        var templates = this.getTemplatesByType(combo, 'event');

        for (let i = 0, ii = templates.length; i < ii; i++) {
          result.push(templates[i].id);
        }

        return result;
      },

      getTemplateIds: function(combo) {
        var i, ii;
        var j, jj;
        var result: TODO[] = [];
        var events = this.getTemplatesByType(combo, 'event');
        var any = this.getTemplatesByType(combo, 'any');

        if (events) {
          for (i=0,ii=events.length;i<ii;i++) {
            result.push(events[i].id);
            console.log('ComboService::getTemplateIds', result);
          }
        }

        if (any) {
          for (i=0,ii=any.length;i<ii;i++) {
            for (j=0,jj=any[i].summaries.length;j<jj;j++) {
              result.push(any[i].summaries[j].id);
              console.log('ComboService::getTemplateIds', result);
            }
          }
        }
        console.log('ComboService::getTemplateIds', events, any);


        return result;
      },

      getTemplatesByType: function(combo, type) {
        var i, ii;
        var templates: TODO[] = [];

        if (combo && combo.templates) {
          if (type) {
            for (i = 0, ii = combo.templates.entries.length; i < ii; i++) {
              if (combo.templates.entries[i].type === type) {
                switch(type) {
                  case 'any':
                    templates.push({
                      fulfilled: false,
                      quantity: combo.templates.entries[i].quantity,
                      summaries: combo.templates.entries[i].summaries
                    });
                    break;
                  case 'event':
                    if (combo.templates.entries[i].summaries) {
                      templates = templates.concat(combo.templates.entries[i].summaries);
                    } else {
                      templates.push(combo.templates.entries[i].template);
                    }
                    break;
                }
              }
            }
          }
        }

        return templates;
      },

      /**
       *
       * Verify combo contains certain type
       *
       * @param combo
       * @param type
       */
      comboContainsType: function(combo, type) {
        let result: TODO = false;

        if (combo && combo.templates) {
          for (let i = 0, ii = combo.templates.entries.length; i < ii; i++) {
            if (combo.templates.entries[i].type === type) {
              result = true;
              break;
            }
          }
        }

        return result;
      }

    };

}]).name;